import { useTranslation } from "react-i18next";
import Button from "../../Button/Button";
import styles from "../TransparentDrawer.module.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useVenuesDataStore } from "@/store/useVenuesDataStore";

function Summary() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { restaurantId } = useParams();
  const { tableId } = useVenuesDataStore();

  return (
    <div className={styles.paymentButtonsGroupWrapper}>
      <Button
        onClick={() => {
          navigate(`/restaurants/${restaurantId}/feedback`);
        }}
        label={t("transparentDrawer.button.continue")}
        variant="contained"
        color="primary"
        maxWidth
        mobile={true}
      />
      <Button
        onClick={() => {
          navigate(`/restaurants/${restaurantId}/tables/${tableId}/bills`);
        }}
        label={t("transparentDrawer.button.backToTheBill")}
        variant="outlined"
        color="primary"
        maxWidth
        mobile={true}
      />
    </div>
  );
}

export default Summary;
